module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18180/js/img/valuePropModals/ReportBuilder/ValueProp2.svg"